<i18n src='@/locale/login-localization.json'></i18n>

<template>
    <v-dialog v-model="vis" persistent max-width="480px">
        <v-form
            ref="loginForm"
            v-model="valid"
            lazy-validation
            @submit.prevent="ValidateAndLogIn"
        >
            <v-card>
                <v-card-title>
                    <span class="text-h5">{{ $t('Text_LogIn') }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col v-if="withCurrentUser" cols="12">
                                <v-text-field
                                    :label="$t('Login_Full_Name')"
                                    :value="fullName"
                                    readonly
                                    :hint="
                                        $t('Another_User_Hint', {
                                            btnName: $t('Another_User_Login'),
                                        })
                                    "
                                    prepend-inner-icon="person"
                                ></v-text-field>
                            </v-col>
                            <v-col v-else cols="12">
                                <v-text-field
                                    :label="$t('Login_User_Name')"
                                    :rules="userRules"
                                    v-model="loginUser"
                                    required
                                    prepend-inner-icon="person"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    :label="$t('Password')"
                                    :rules="passRules"
                                    v-model="loginPass"
                                    :type="passVis ? 'text' : 'password'"
                                    required
                                    prepend-inner-icon="lock"
                                    :append-icon="
                                        passVis ? 'mdi-eye' : 'mdi-eye-off'
                                    "
                                    @click:append='passVis = !passVis'
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        v-if="withCurrentUser"
                        @click="
                            withCurrentUser = false;
                            loginUser = '';
                            userRules = [];
                            passRules = [];
                            FocusFirstInp();
                        "
                        text
                        class="text-capitalize"
                    >
                        <v-icon left color="grey darken-2"
                            >switch_account</v-icon
                        >
                        {{ $t('Another_User_Login') }}
                    </v-btn>
                    <v-btn
                        v-else-if="fullName"
                        @click="
                            withCurrentUser = true;
                            loginUser = $store.state.UserName;
                            userRules = [];
                            passRules = [];
                            FocusFirstInp();
                        "
                        text
                        class="text-capitalize"
                    >
                        <v-icon left color="grey darken-2">arrow_back</v-icon>
                        {{ $t('Current_User_Login') }}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn type="submit" color="blue darken-1" text>{{
                        $t('Text_LogIn')
                    }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
import globalDataService from '@/script/global-data-service.js';

export default {
    name: 'LoginOverlay',
    mounted() {
        this.FocusFirstInp();
    },
    data() {
        return {
            vis: true,
            valid: true,
            fullName:
                this.$store.state.UserName &&
                this.$store.state.PersonCode &&
                this.$store.state.FullName,
            withCurrentUser:
                this.$store.state.UserName &&
                this.$store.state.PersonCode &&
                !!this.$store.state.FullName,
            loginUser:
                this.$store.state.PersonCode && this.$store.state.UserName,
            loginPass: '',
            passVis: false,
            userRules: [],
            passRules: [],
        };
    },
    methods: {
        FocusFirstInp() {
            this.$nextTick(() => {
                const formElement = this.$refs.loginForm;

                formElement.resetValidation();

                const input = formElement.$el.querySelector(
                    'input:not([readonly="readonly"])'
                );
                if (input) {
                    setTimeout(() => {
                        input.focus();
                    }, 0);
                }
            });
        },

        ValidateAndLogIn() {
            //[alphanumeric _ .]
            // no _ or . at the beginning/end
            // no __ or _. or ._ or .. inside
            this.userRules = [
                (v) => !!v || this.$t('Login_User_Required'),
                (v) =>
                    /^(?![_.])(?!.*[_.]{2})[a-zA-Z0-9._]+(?<![_.])$/.test(v) ||
                    this.$t('Invalid_Value'),
            ];
            this.passRules = [(v) => !!v || this.$t('Login_Password_Required')];

            this.$refs.loginForm.validate();

            this.$nextTick(() => {
                if (this.valid) {
                    if (this.withCurrentUser) {
                        globalDataService.setGlobalData().then(() => {
                            this.$store.commit('HideLogin');
                        });
                    } else {
                        location.assign('/');
                    }
                }
            });
        },
    },
};
</script>

<style scoped lang="scss">
</style>
